var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "pad30" },
        [
          _c("h2", { staticClass: "f18 fb normal gray_2" }, [
            _vm._v("员工管理")
          ]),
          _c("div", { staticClass: "box20" }),
          _c(
            "div",
            { staticClass: "flex flex-wrap flex1 items-center mar20-b" },
            [
              _c(
                "div",
                [
                  _c("el-input", {
                    staticClass: "w200 mar20_r",
                    attrs: { placeholder: "请输入员工姓名或手机号" },
                    model: {
                      value: _vm.phoneOrName,
                      callback: function($$v) {
                        _vm.phoneOrName =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "phoneOrName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.phoneOrName = ""
                    }
                  }
                },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getStaffList } },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "mar-20-l",
                  attrs: { type: "primary" },
                  on: { click: _vm.openAddStaff }
                },
                [_vm._v("引入员工")]
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.staffList, "row-key": "shopStaffId" },
              on: { "selection-change": _vm.staffSelect }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  "reserve-selection": true,
                  width: "55"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "boName",
                  label: "员工姓名"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "mobilePhoneCn", label: "联系电话" }
              }),
              _vm.cateModel &&
              _vm.cateModel.funcSettingMap &&
              _vm.cateModel.funcSettingMap.is_staff_sync == "1"
                ? _c("el-table-column", {
                    attrs: { prop: "deptName", label: "所属部门" }
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "operationName", label: "创建人" }
              }),
              _c("el-table-column", {
                attrs: { prop: "creationDate", label: "创建时间" }
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "240" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.editStaff(scope.row)
                                }
                              }
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "mar15-l",
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteStaff(scope.row)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1260264393
                )
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex items-center mar20-t" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: this.multipleSelection.length == 0
                  },
                  on: { click: _vm.deleteStaffList }
                },
                [_vm._v("批量删除 ")]
              ),
              _c("div", { staticClass: "gray9 flex-auto mar-20-l" }, [
                _vm._v(
                  "共 " +
                    _vm._s(_vm.pageTotal) +
                    " 条记录 第 " +
                    _vm._s(_vm.pageNum) +
                    " / " +
                    _vm._s(_vm.totalPage) +
                    " 页"
                )
              ]),
              _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next, sizes, jumper",
                  background: "",
                  "hide-on-single-page": "",
                  "page-size": _vm.pageSize,
                  "page-count": _vm.totalPage,
                  "current-page": _vm.pageNum,
                  "page-sizes": [6, 10, 20]
                },
                on: {
                  "update:pageSize": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  },
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.currentChange
                }
              })
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: { title: "编辑员工", visible: _vm.dialogEditVisible },
              on: {
                "update:visible": function($event) {
                  _vm.dialogEditVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.editStaffForm } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "员工手机号",
                        "label-width": _vm.formLabelWidth,
                        prop: "mobilePhone"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, autocomplete: "off" },
                        model: {
                          value: _vm.editStaffForm.mobilePhone,
                          callback: function($$v) {
                            _vm.$set(_vm.editStaffForm, "mobilePhone", $$v)
                          },
                          expression: "editStaffForm.mobilePhone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "员工姓名",
                        "label-width": _vm.formLabelWidth,
                        prop: "boName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.boObj.boName ? true : false,
                          autocomplete: "off"
                        },
                        model: {
                          value: _vm.editStaffForm.boName,
                          callback: function($$v) {
                            _vm.$set(_vm.editStaffForm, "boName", $$v)
                          },
                          expression: "editStaffForm.boName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.cateModel &&
                  _vm.cateModel.funcSettingMap &&
                  _vm.cateModel.funcSettingMap.is_staff_sync == "1"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "所属部门",
                            prop: "deptId",
                            "label-width": _vm.formLabelWidth
                          }
                        },
                        [
                          _c("el-cascader", {
                            staticClass: "w100-full",
                            attrs: {
                              options: _vm.deptData,
                              props: _vm.deptProps,
                              filterable: "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.editStaffForm.deptId,
                              callback: function($$v) {
                                _vm.$set(_vm.editStaffForm, "deptId", $$v)
                              },
                              expression: "editStaffForm.deptId"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          ;(_vm.dialogEditVisible = false),
                            (_vm.editStaffForm = {})
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.confirmLoading },
                      on: { click: _vm.submitStaffForm }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "引入员工",
                visible: _vm.dialogAddVisible,
                width: "550px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogAddVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "addStaffForm",
                  staticClass: "seller-style",
                  attrs: {
                    model: _vm.addStaffForm,
                    "label-width": "100px",
                    "label-suffix": " : "
                  }
                },
                [
                  _c(
                    "el-alert",
                    {
                      attrs: {
                        title: "",
                        type: "success",
                        closable: false,
                        "show-icon": ""
                      }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "title" }, slot: "title" },
                        [
                          _vm._v(
                            "\n          未注册过的员工填写姓名后会通过手机号自动注册\n          "
                          ),
                          _vm.cateModel &&
                          _vm.cateModel.funcSettingMap &&
                          _vm.cateModel.funcSettingMap.is_staff_sync == "1"
                            ? [
                                _vm._v("\n            ，所属部门基础信息可在"),
                                _c(
                                  "span",
                                  {
                                    staticClass: "pointer mar10-l fb",
                                    on: { click: _vm.toDept }
                                  },
                                  [_vm._v("【部门设置】")]
                                ),
                                _vm._v("菜单中维护\n          ")
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  ),
                  _c("div", { staticClass: "box10" }),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "员工手机号",
                        prop: "mobilePhone",
                        rules: _vm.addStaffFormRule.mobilePhone
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "number",
                          maxlength: "11",
                          placeholder: "请输入员工手机号",
                          autocomplete: "off",
                          oninput:
                            "if(value.length > 11) value=value.slice(0, 11)"
                        },
                        on: { input: _vm.getUserByPhone },
                        model: {
                          value: _vm.addStaffForm.mobilePhone,
                          callback: function($$v) {
                            _vm.$set(_vm.addStaffForm, "mobilePhone", $$v)
                          },
                          expression: "addStaffForm.mobilePhone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "员工姓名",
                        prop: "boName",
                        rules: _vm.addStaffFormRule.boName
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入员工姓名",
                          disabled: _vm.disabled
                        },
                        model: {
                          value: _vm.addStaffForm.boName,
                          callback: function($$v) {
                            _vm.$set(_vm.addStaffForm, "boName", $$v)
                          },
                          expression: "addStaffForm.boName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.cateModel &&
                  _vm.cateModel.funcSettingMap &&
                  _vm.cateModel.funcSettingMap.is_staff_sync == "1"
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "5px" },
                          attrs: { label: "所属部门", prop: "deptId" }
                        },
                        [
                          _c("el-cascader", {
                            staticClass: "w100-full",
                            attrs: {
                              options: _vm.deptData,
                              props: _vm.deptProps,
                              filterable: "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.addStaffForm.deptId,
                              callback: function($$v) {
                                _vm.$set(_vm.addStaffForm, "deptId", $$v)
                              },
                              expression: "addStaffForm.deptId"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogAddVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.confirmLoading },
                      on: { click: _vm.submitStaffFormAdd }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _c("div", { staticStyle: { "min-height": "900px" } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }